import React from 'react';
import './GalleryPage.css';
 
import { PageTitle } from '../../../components';
import { Gallery } from '../..';


const GalleryPage = () => {

  return (
    <>
      <PageTitle title={'gallery'} page={'gallery'} />
      <Gallery />
    </>

  )
}

export default GalleryPage;